import * as React from 'react';
export const samsungPaySvg = React.forwardRef(function samsungPaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1F4AC7',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.798 12.72c-.27-2.043-.994-3.893-2.269-5.249-1.356-1.275-3.206-1.998-5.25-2.27C17.33 4.943 16 5.008 16 5.008s-1.328-.063-3.28.195c-2.043.27-3.893.994-5.249 2.269-1.275 1.356-1.998 3.207-2.27 5.25C4.943 14.67 5.008 16 5.008 16s-.063 1.328.195 3.28c.27 2.043.994 3.893 2.269 5.249 1.356 1.275 3.207 1.998 5.25 2.27 1.95.259 3.279.194 3.279.194s1.328.063 3.28-.195c2.043-.27 3.893-.994 5.249-2.269 1.275-1.356 1.998-3.206 2.27-5.25.259-1.95.194-3.279.194-3.279s.063-1.328-.195-3.28Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.05 12.777h1.975a2.056 2.056 0 0 1 1.485.6 2.026 2.026 0 0 1 .591 1.454 2.073 2.073 0 0 1-.59 1.461c-.185.185-.405.33-.66.438a2.112 2.112 0 0 1-.834.161h-.892v1.65H9.051v-5.768.004Zm1.075.996V15.9h.822c.157 0 .302-.027.434-.082a.998.998 0 0 0 .34-.23 1.07 1.07 0 0 0 .3-.755c0-.147-.025-.285-.078-.414a.984.984 0 0 0-.222-.336 1.082 1.082 0 0 0-.774-.308h-.822Zm5.461 4.779c-.28 0-.554-.052-.826-.156a2.24 2.24 0 0 1-1.252-1.18 2.322 2.322 0 0 1-.197-.979c0-.365.064-.7.194-.986.13-.287.3-.529.513-.727.214-.199.458-.35.735-.454.277-.104.56-.157.848-.157.305 0 .588.055.845.165.258.11.472.261.64.452v-.61h1.068v4.624h-1.067v-.657c-.17.207-.385.37-.649.488a2.064 2.064 0 0 1-.852.177Zm.172-.98c.2 0 .386-.036.555-.105.169-.069.312-.165.434-.289.122-.124.218-.267.289-.43a1.32 1.32 0 0 0 .106-.527 1.34 1.34 0 0 0-.395-.945 1.293 1.293 0 0 0-.434-.285 1.456 1.456 0 0 0-.554-.104 1.45 1.45 0 0 0-.997.385c-.125.118-.226.26-.296.423-.071.163-.106.34-.106.526a1.327 1.327 0 0 0 .402.961c.126.122.275.216.446.285.171.069.354.104.55.104Zm4.639.773-1.896-4.422h1.138l1.287 3.16 1.216-3.16h1.122l-2.757 6.746h-1.083l.973-2.324Z',
      fill: '#1F4AC7',
    }),
  );
});
samsungPaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var samsungPay = {
  category: 'brand',
  colorable: false,
  name: 'samsungPay',
  svg: samsungPaySvg,
};
